import { FC } from "react";

export interface AudienceCellProps {
	groups: { id: number; name: string }[];
}

/**
 * Renders the Audience column for content-list tables that support
 * group-restricted visibility (carousel banners, key shouts, promotions,
 * quick links, full-screen takeovers, etc.).
 *
 * - Empty list → green "Everyone" pill (no restrictions).
 * - Non-empty → one chip per group.
 *
 * Pill chrome mirrors the existing Live/Draft status pills in `ContentTable`.
 */
const AudienceCell: FC<AudienceCellProps> = ({ groups }) => {
	if (groups.length === 0) {
		return (
			<span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-emerald-50 text-emerald-700">
				Everyone
			</span>
		);
	}

	return (
		<div className="flex flex-wrap gap-1.5">
			{groups.map((g) => (
				<span
					key={g.id}
					className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-primary/10 text-primary"
				>
					{g.name}
				</span>
			))}
		</div>
	);
};

export default AudienceCell;
